<template>
  <section class="col-md-12 col-xs-12 block-card-list">
    <credit-card v-if="showCards > index" v-for="(card, index) in cards" class="col-md-12 col-xs-12"
                 :card="card"
                 :key="card.details.uid"
    />
    <div class="col-md-12 col-xs-12 mb10">
      <span class="load-more" @click="loadMore" v-if="cards.length >= showCards">
        {{ $t('Load more card') }}
      </span>
    </div>
    <div class="add-new-card" :class="{ 'position-right': isUserExists }">
      <template v-if="!registerLinkLoading">
        <button-full v-if="!isUserExists" @click.native="openRegisterLink">
          {{ isUserInvited ? $t('Connect iPay') : $t('Create wallet and add my first card') }}
        </button-full>
        <button-full v-else class="button-add-new-card" @click.native="openAddCardLink">
          {{ $t('Add another card') }}
        </button-full>
      </template>
      <template v-else>
        <button-full class="button-add-new-card" disabled>
          {{ $t('Register Link is loading') }}
        </button-full>
      </template>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreditCard from '../../../../../../../modules/ipay-payment/components/CreditCard'
import ButtonFull from '../../../../theme/ButtonFull'

export default {
  name: 'PayOrderModalCreditCardsList',
  components: {
    CreditCard,
    ButtonFull
  },
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showCards: 5,
      registerLink: null,
      addCardLink: null,
      registerLinkLoading: false
    }
  },
  async created () {
    await this.getUserStatus({
      customerId: this.getCustomerId,
      phoneNumber: this.getPhoneNumber(false)
    })
    .then(async () => {
      this.registerLinkLoading = true
      if (!this.isUserExists && !this.isUserInvited) {
        await this.getRegisterLink({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(false),
          lang: 'ua',
          successUrl: this.successUrl
        })
        .then(res => {
          this.registerLink = res.result.url
          this.registerLinkLoading = false
        })
      } else if (this.isUserInvited) {
        await this.getInviteLink({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(false),
          lang: 'ua',
          successUrl: this.successUrl
        })
        .then(res => {
          this.registerLink = res.result.url
          this.registerLinkLoading = false
        })
      } else {
        await this.loadCards({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(false),
          token: this.getCustomerToken
        })
        .then(() => {
          if (this.cards.length) {
            let defaultCC = this.cards.find(c => c.is_default)
            if (defaultCC) {
              this.$emit('selected-card', defaultCC.details.card_alias)
            }
          }
        })
        await this.getAddCardLink({
          customerId: this.getCustomerId,
          phoneNumber: this.getPhoneNumber(false),
          lang: 'ua',
          successUrl: this.successUrl
        })
        .then(res => {
          this.addCardLink = res.result.url
          this.registerLinkLoading = false
        })
      }
    })
  },
  computed: {
    ...mapGetters({
      isUserExists: 'ipay-payment-user/isUserExist',
      isUserInvited: 'ipay-payment-user/isUserInvited',
      cards: 'ipay-payment-user/getCards',
      currentLocation: 'locations/getActiveLocation',
      getPhoneNumber: 'user/getPhoneNumber'
    }),
    getCustomerId () {
      return this.$store.state.user.current.id
    },
    getCustomerToken () {
      return this.$store.state.user.token
    },
    successUrl () {
      return window ? `${window.location.href}?pay_for=${this.orderId}` : `/my-account/orders/?pay_for=${this.orderId}`
    }
  },
  methods: {
    ...mapActions({
      loadCards: 'ipay-payment-user/getCardsList',
      getUserStatus: 'ipay-payment-user/getUserStatus',
      getRegisterLink: 'ipay-payment-user/getRegisterLink',
      getInviteLink: 'ipay-payment-user/getInviteLink',
      getAddCardLink: 'ipay-payment-user/getAddCardLink'
    }),
    openRegisterLink() {
      if (this.registerLink && window) {
        window.open(this.registerLink, '_self')
      }
    },
    openAddCardLink () {
      if (this.addCardLink && window) {
        window.open(this.addCardLink, '_self')
      }
    },
    loadMore () {
      if (this.cards.length > this.showCards) {
        this.showCards += 3
      }
    }
  }
}
</script>

<style scoped lang="scss">
.block-card-list {
  padding: 0 70px;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 520px) {
    padding: 0;
  }
}

.col-md-6 {
  @media only screen and (min-width: 769px) {
    flex-basis: 48%;
    max-width: 48%;
  }
}

.add-new-card {
  width: 100%;
  margin: 15px 0;

  display: flex;
  justify-content: center;

  &.position-right {
    justify-content: flex-end;
  }
}

.button-add-new-card {
  width: auto;
  min-width: 100px;

  padding: 10px 0 !important;
  float: right;

  color: #11bb2e !important;
  font-size: 16px !important;
  font-weight: 400 !important;

  background: none !important;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.load-more {
  color: #11bb2e;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.05px;
  text-align: center;
  cursor: pointer;
}
</style>
